import React from "react";
import { motion } from "framer-motion"; // Importing framer-motion for scroll animations
import "../../assets/styles/ourCompany.css";
import services from "../../assets/images/services.svg";
import { useNavigate } from "react-router-dom";

const Services = ({ title, subtitle, stats }) => {

  const navigate = useNavigate(); 
  return (
    <div className="ourCompany-section">
      {/* Animated Header Section */}
      <header className="text-center py-5">
        <motion.div
          className="text-box"
          initial={{ opacity: 0, x: -50 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: false, amount: 0.3 }}
          transition={{ duration: 1.5, ease: "easeInOut" }}
        >
          <motion.h1
            className="title"
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: false, amount: 0.3 }} // Trigger animation when 30% is in view
            transition={{ duration: 1.5, ease: "easeInOut" }}
          >
            OUR COMPANY
          </motion.h1>
          <br />
          <motion.p
            className="subtitle"
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: false, amount: 0.3 }}
            transition={{ duration: 1.5, ease: "easeInOut", delay: 0.2 }}
          >
            At commceed, we believe that life should flow effortlessly every
            hour, every day, across the globe. Our team is dedicated to building
            a world you can rely on. As a leading provider of global supply
            chain solutions, we transform inspiration into innovation. Through
            our unique expertise, we create solutions that redefine the way you
            do business.
          </motion.p>
          <motion.button className="ourCompanyBtn" whileHover={{ scale: 1.1 }} onClick={() => navigate("/ourCompany")}>
            Learn More
          </motion.button>
        </motion.div>
      </header>
    </div>
  );
};

export default Services;
